import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

export const useIsCardPullEnabled = () => {
  const {
    flags: {
      useMulticardCrafting = { baseball: false, nba: false, football: false },
    },
  } = useFeatureFlags();
  const { sport } = useSportContext();

  return useMulticardCrafting[sport.toLowerCase()];
};
